export enum AgeCategory {
    ALL_AGES = 'All Ages',
    ADULT = 'Adult',
    YOUNG_ADULT = 'Young Adult',
    CHILDREN = 'Children'
}

export const ageCategoryFromString = (c?: string): AgeCategory => {
    const categoryKey = Object.keys(AgeCategory).find(key => AgeCategory[key] === c);

    return categoryKey ? AgeCategory[categoryKey] : AgeCategory.ALL_AGES;
};
